<template>
  <div class="timezones">
    <v-card>
      <v-card-title>
        <v-text-field
          color="#00677A"
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="tz"
        :items-per-page="15"
        item-key="id"
        :selectable-key="id"
        dense
        show-select
        single-select
        v-model="selectedTimeZone"
        :search="search"
        v-on:item-selected="onSelected"
      ></v-data-table>
    </v-card>
  </div>
</template>

<script>
  export default {
  data: () => ({
    search: null,
    tz_countries: [],
    tx_continents: [],
    timezoneCountry: null,
    timezoneContinent: null,
    headers: [
        {text: "Id", value: "id"},
        {text: "Abbreviation", value: "abbr"},
        {text: "Offset", value: "offset"},
    //    {text: "Country", value: "country"},
    //    {text: "Continent", value: "continent"},
    ],
    selectedTimeZone: [],
  }),
  props: {
    timezones: [],
    timezone: String,
  },

  mounted () {  
    if( this.selectedTimeZone != null && this.timezones != null) {
      this.selectedTimeZone.push(this.timezones.find(x => x.id === this.timezone))
      console.log("selectedTimeZone",this.selectedTimeZone)
    }
  },
  methods: {
    onSelected() {
        this.$nextTick(() => {
          if (this.selectedTimeZone && this.selectedTimeZone.length > 0) {
            this.$emit('selectedTimeZoneId', this.selectedTimeZone[0].id);
          } else {
            this.$emit('selectedTimeZoneId', null);
          }
        });
    }
  },
  computed: {
    tz() {
      let t = []
      for(var i=0; i < this.timezones.length; i++) {
        let desc = this.timezones[i].id + " " + this.timezones[i].abbr + "  ("  + this.timezones[i].offset + ")"
        t.push({id: this.timezones[i].id, abbr: this.timezones[i].abbr, offset: this.timezones[i].offset, country: this.timezones[i].country, continent: this.timezones[i].continent,   name: desc})
      }
      return t
    },
    countries() {
      if (!this.timezones) return [];
      const countryNames = [...new Set(this.timezones.map(tz => tz.country))];
      return countryNames.filter(Boolean).sort();
    },
    continents() {
      if (!this.timezones) return [];
      const continentNames = [...new Set(this.timezones.map(tz => tz.continent))];
      return continentNames.filter(Boolean).sort();
    }
  },
}
</script>

<style>

</style>